export default __webpack_public_path__ + "static/media/R&D.082de554.png";